# Note: to use this, place amount-toggle-describedby directive on forms
# that contain visible inputs(and select tags) that need to toggle aria-describedby.
# Then broadcast the "form:invalid" as needed.
angular.module("avant.customer_applications.directives").directive "amountToggleDescribedby", () ->
  link: (scope, element, attr) ->
    scope.toggleDescribedby = (elem) ->
      angular.forEach elem.find('input, select').not('input[type="hidden"]'), (input) ->
        if input.classList.contains("ng-invalid")
          input.setAttribute('aria-describedby', input.getAttribute("describedby-invalid") || '')
        else if input.classList.contains("ng-valid")
          input.setAttribute('aria-describedby', input.getAttribute("describedby-valid") || '')

    scope.$on("form:invalid", () ->
      scope.toggleDescribedby(element)
    )
